import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Tag, message, Modal, Card} from "antd";
import { ShoppingCartOutlined, CheckCircleFilled } from "@ant-design/icons";
import { addToCart } from "../../Redux/slice/cartSlice";
import { fetchProductsByBrand } from "../../Redux/slice/productSlice";
import { useNavigate } from "react-router-dom";
import productImage from "../../assets/realme.jpg";
const formatPrice = (price) => price.toLocaleString();
const BRAND_ID = "86cca959-70a4-448e-86f1-3601309f49a6";
const backendBaseURL = "https://smfteapi.salesmate.app";

const Tecno = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { products, loading } = useSelector((state) => state.products);
  const cartItems = useSelector((state) => state.cart.cart);
  const cartId = useSelector((state) => state.cart.cartId);

  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchProductsByBrand(BRAND_ID));
  }, [dispatch]);

  const product = {
    productID: "Tecno",
    productName: "Realme C53 (Rmx3760) (256gb+8gb)",
    description: `📱 Display: 6.74" 90Hz  
💾 Storage: 256GB | RAM: 8GB  
⚡ Processor: Powerful Octa-Core Chipset  
📷 Camera: 50MP AI Camera  
🔋 Battery: 5000mAh | 33W SUPERVOOC Charge  
📡 Network: Dual SIM  
📶 Connectivity: NFC | USB Type-C  
📏 Design: 7.49mm Ultra Slim  
🎁 Includes: Phone Cover & Type-C Charger  

`,
    price: 1600,
    productImage: productImage,
    categoryName: "Phones",
    brandName: "Tecno",
    showRoomName: "Explore our Products",
  };



  const handleAddToCart = async (selectedProduct) => {
    if (cartItems.some((item) => item.productID === selectedProduct.productID)) {
      message.warning("Product is already in the cart.");
      return;
    }

    setIsAddingToCart(true);
    try {
      await dispatch(
        addToCart({
          cartId,
          productId: selectedProduct.productID,
          price: selectedProduct.price,
          quantity: 1,
        })
      );
      message.success("Product added to cart successfully!");
    } catch (error) {
      message.error(`Failed to add product: ${error.message}`);
    } finally {
      setIsAddingToCart(false);
    }
  };

  const filteredProducts = products.filter((item) => item.productID !== product.productID);

  return (
    <div className="container mx-auto p-4 min-h-screen flex flex-col">
      <div className="flex flex-col lg:flex-row bg-white rounded-xl shadow-lg p-6 w-full gap-6">
        {/* Product Image */}
        <div className="flex-1 flex justify-center">
          <img
            src={productImage}
            alt={product.productName}
            className="rounded-lg w-full max-w-md object-cover shadow-md cursor-pointer hover:scale-105 transition-transform duration-300"
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        {/* Product Details */}
        <div className="flex-1 flex flex-col gap-4">
          <h2 className="text-2xl font-bold">{product.productName}</h2>
          <p className="text-red-600 font-bold text-xl">₵{formatPrice(product.price)}.00</p>

          <div className="bg-gray-100 p-4 rounded-lg">
            <div className="flex items-center gap-2">
              <CheckCircleFilled className="text-green-500 text-lg" />
              <span className="font-medium">Availability:</span>
              <span className="text-green-500">In Stock</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <Tag color="orange">{product.showRoomName}</Tag>
            <Tag color="green">{product.categoryName}</Tag>
            <Tag color="red">{product.brandName}</Tag>
          </div>

          <p className="text-gray-600 whitespace-pre-line">{product.description}</p>

          <Button
            type="primary"
            icon={<ShoppingCartOutlined />}
            className="w-full bg-red-400 hover:bg-green-600 border-none text-white py-3 font-semibold"
            onClick={() => handleAddToCart(product)}
            loading={isAddingToCart}
          >
            {isAddingToCart ? "Adding..." : "Add to Cart"}
          </Button>
        </div>
      </div>

      {/* Sticky Add to Cart Button (Mobile) */}
         

      {/* For You Section */}
      <div className="w-full  py-4 px-4 mt-2">
        <div className="w-full bg-green-500 px-4 rounded-md">
        <h2 className="text-lg font-semibold text-white">For You</h2>
        </div>
        {loading ? (
           <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
           {Array.from({ length: 8 }).map((_, index) => (
             <div
               key={index}
               className="animate-pulse border rounded-lg shadow p-3 bg-gray-100 relative"
             >
               <div
                 className="absolute inset-0 bg-center bg-no-repeat opacity-10"
                 style={{
                   backgroundImage: "url('/frankoIcon.png')",
                   backgroundSize: '90px',
                   backgroundPosition: 'center center',
                 }}
               ></div>
               <div className="h-36 bg-gray-200 rounded-lg"></div>
               <div className="h-3 bg-gray-200 rounded w-3/4 mt-2"></div>
               <div className="h-3 bg-gray-200 rounded w-1/2 mt-1"></div>
             </div>
           ))}
         </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
            {filteredProducts.map((item) => (
              <Card
                key={item.productID}
                hoverable
                className="rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-lg group"
                cover={
                  <div
                    onClick={() =>
                      navigate(`/product/${item.productID}`)
                    }
                    className="cursor-pointer relative"
                  >
                    <img
                      src={`${backendBaseURL}/Media/Products_Images/${item.productImage.split("\\").pop()}`}
                      alt={item.productName}
                      className="w-full object-cover rounded-lg"
                    />
                  </div>
                }
              >
                <Card.Meta
                  title={<p className="font-semibold text-sm truncate">{item.productName}</p>}
                  description={<p className="text-red-500 font-bold text-sm">₵{formatPrice(item.price)}.00</p>}
                />
                <Button
                  shape="circle"
                  icon={<ShoppingCartOutlined />}
                  className="absolute bottom-2 right-2 bg-red-500 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart(item);
                  }}
                />
              </Card>
            ))}
          </div>
        )}
      </div>

      {/* Modal for Enlarged Image */}
      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} centered>
        <img src={productImage} alt="Enlarged Product" className="w-full rounded-lg" />
      </Modal>
    </div>
  );
};

export default Tecno;
